import '../css/index.scss';
import $ from 'jquery';
import { setupLenis } from '../scripts/lenis.js';
import Rellax from 'rellax';

/**js**/
'use strict';


let windowWidth = $(window).width();
let windowHeight = $(window).height();
let adjust = null;
let saveStopPOS = 0;
const BREAKPOINT_SP = 768;

const setup = () => {

  // Lenis.js
  const lenis = setupLenis();

  // UA
  const _ua = (function(u){
    return {
      Tablet:(u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1) 
        || u.indexOf("ipad") != -1
        || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
        || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
        || u.indexOf("kindle") != -1
        || u.indexOf("silk") != -1
        || u.indexOf("playbook") != -1,
      Mobile:(u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
        || u.indexOf("iphone") != -1
        || u.indexOf("ipod") != -1
        || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
        || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
        || u.indexOf("blackberry") != -1
    }
  })(window.navigator.userAgent.toLowerCase());
  
  if(!_ua.Mobile && !_ua.Tablet){
    // RELLAX
    var rellax = new Rellax('.rellax', {
      speed: 2,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false,
    });
    rellax.refresh();
  }

  // swiper stop
  heroSwiper.autoplay.stop();

  // アンカーリンクを取得
  const anchors = document.querySelectorAll('.nav-item-link');
  anchors.forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      // urlを変更しないようにする
      e.preventDefault();
      // スクロール
      lenis.scrollTo( '#' + this.getAttribute('data-target'))
    });
  });

};

window.addEventListener('load',function(){

  // let vw = window.innerWidth;
  // document.documentElement.style.setProperty('--vw', `${vw}px`);
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  if (windowWidth <= BREAKPOINT_SP) {
    adjust = windowHeight * .25;
  } else {
    adjust = windowHeight * .15;
  }

  // progressbar.js
  var ProgressBar = require('progressbar.js');
  var line = new ProgressBar.Line('#loading .progressBar', {
    strokeWidth: 1,
    easing: 'easeInOut',
    duration: 1400,
    color: '#5484B2',
    trailColor: '#fff',
    trailWidth: 1,
    svgStyle: {width: '100.0%', height: '20.0%'},
  });

  line.animate(1.0, function () {

    // Loading fadeout
    $("#loading").delay(400).fadeOut(800);

    setup();

    const body = document.querySelector( 'body' );
    setTimeout(() => {
      body.classList.add('opening');
      setTimeout(() => {
        body.classList.add('complete');
        body.classList.remove('opening');

        // swiper
        heroSwiper.autoplay.start();
        bar.style.transitionDuration = speed + 'ms',
        bar.style.transform = 'scaleY(1)';

      }, 4000);
    }, 400);
  });

});


// resize
var resizeTimer;
var interval = 1000;

window.addEventListener('resize', function() {

  if (resizeTimer !== false) {
    clearTimeout(resizeTimer);
  }

  resizeTimer = setTimeout(function() {
    windowHeight = $(window).height();

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    //スマホとタブレットではなかったら読み込む
    if(!_ua.Mobile && !_ua.Tablet){
      // RELLAX
      var rellax = new Rellax('.rellax', {
        speed: 2,
        center: true,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false,
      });
      rellax.refresh();
    }

  }, interval);

});


// modal

const dialogOpenButtons = document.querySelectorAll(".js-modal-open-button");
const dialogCloseButtons = document.querySelectorAll(".js-modal-close-button");

dialogOpenButtons.forEach((button) => {
  const dialog = document.querySelector(button.dataset.dialog);

  button.addEventListener("click", () => {
    // dialog.showModal();

    saveStopPOS = window.scrollY;
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.position = 'fixed';

    dialog.showModal();
    lenis.stop();
  });
});

dialogCloseButtons.forEach((button) => {
  const dialog = button.closest("dialog");

  button.addEventListener("click", () => {
    document.body.style.top = '';
    document.body.style.position = '';
    window.scrollTo(0, saveStopPOS);
    saveStopPOS = 0;

    dialog.close();
    lenis.start();
  });
});


$(function(){

  // animate
  var current_scrollY;
  current_scrollY = $( window ).scrollTop();
  triggerAnimation(current_scrollY);

  $(window).on('scroll', function () {
    current_scrollY = $( window ).scrollTop();
    triggerAnimation(current_scrollY);
  });

  function triggerAnimation(scroll) {
    const scrollBottom = scroll + $(window).height();
    $('.animate').each(function() {
      const top = $(this).offset().top + adjust;
      if(scrollBottom > top) {
        $(this).addClass('is_animated');
      } else {
        // $(this).removeClass('is_animated');
      }
    })
  }

  // anchor
  var anchor = function () {
    const targetOffset01 = $('#campaign').offset().top;
    const targetOffset02 = $('#intro').offset().top;
    const targetOffset03 = $('#about').offset().top;
    const targetOffset04 = $('.l-footer').offset().top;
    const scrollpos = $( window ).scrollTop();

    if (scrollpos > targetOffset02 && scrollpos < (targetOffset01 - windowHeight) || scrollpos > (targetOffset03 - windowHeight) &&  scrollpos < (targetOffset04 - windowHeight)) {
      if ( scrollpos < (targetOffset01 - windowHeight)) {
        $(".btn-campaign .c-circle-arrow").removeClass('up-arrow');
        $(".btn-campaign .c-circle-arrow").addClass('down-arrow');
      } else {
        $(".btn-campaign .c-circle-arrow").removeClass('down-arrow');
        $(".btn-campaign .c-circle-arrow").addClass('up-arrow');
      }
      $(".btn-campaign").addClass('is-active');
    } else {
      $(".btn-campaign").removeClass('is-active');
    }
  };
  $(window).on("scroll", anchor);


  /*----------------------------------------------------------
    drawer-nav
  ----------------------------------------------------------*/

  const gNavi = $('.drawer-nav');
  const gNaviButton = $('.js-drawer-nav');

  gNaviButton.on('click', function(){
    $('body').toggleClass('is-open');
  });

  $('.drawer-nav a.nav-item-link').on('click', function(){
    $('body').toggleClass('is-open');
  });

  $('.btn-campaign a.nav-item-link').on('click', function(){
    if($('body').hasClass('is-open')) {
      $('body').toggleClass('is-open');
    }
  });

});


/*----------------------------------------------------------
  swiper
----------------------------------------------------------*/

let bar = document.querySelector('.progressbar_in');
const speed = 2400;

const heroSwiper = new Swiper('.hero-image .swiper', {
  loop: true,
  effect: 'fade',
  speed: 1000,
  autoplay: {
    delay: speed,
    disableOnInteraction: false,
  },
  on: {
    init: function() {
      updateExtraPagination(this);
      bar.style.transitionDuration = '0s',
      bar.style.transform = 'scaleY(0)'
    },
    slideChangeTransitionStart: function() {
      updateExtraPagination(this);
      bar.style.transitionDuration = '0s',
      bar.style.transform = 'scaleY(0)'
    },
    slideChangeTransitionEnd: function() {
      bar.style.transitionDuration = speed + 'ms',
      bar.style.transform = 'scaleY(1)'
    },
  }
});

function updateExtraPagination(swiper) {
  let currentIndex = swiper.realIndex + 1;
  let totalSlides = swiper.slides.length;
  document.querySelector(".current").textContent = currentIndex;
  document.querySelector(".total").textContent = totalSlides;
}


/*----------------------------------------------------------
Google Analytics
----------------------------------------------------------*/

$(function() {

  var url = location.href;
  var pvData = [];

  $('[data-preview]').each(function() {
    var position = $(this).offset().top;
    var data = $(this).attr('data-preview');
    pvData.push({position: position, data: data});
    //console.log(pvData[0].position);
  });


  $(window).on('orientationchange scroll load resize', function(){
    var windowHeight = $(window).height();
    var scrollPosition = $(window).scrollTop();

    $('[data-preview]').not('.processed').each(function() {
      var position = $(this).offset().top - windowHeight * .5;
      var data = $(this).attr('data-preview');
      if (scrollPosition > position) {
        $(this).addClass('processed');
        GAsend(data);
      }
    });
  });

  function GAsend(data){
    var PATH = '#' + data;
    ga('set', 'location', url + PATH);
    ga('send', 'pageview');
    //console.log('GAsend: ' + url + PATH );
  }

});